var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import { StyledTitle, TitleContent, TitlePlaceholder, TitleInput } from './Title.Styles';
import { useFirebase } from '@web/firebase';
import { usePage, usePageEdit } from '../../';
import { toast } from '../../../Toast';
import { LazyLoadPlaceholder } from '../../../LazyLoadPlaceholder';
import { H1 } from '../../../Typography';
export var Title = memo(function () {
    var addOrUpdatePage = useFirebase().addOrUpdatePage;
    var _a = usePage().page, data = _a.data, isFetching = _a.isFetching;
    var _b = usePageEdit(), pageInEditMode = _b.pageInEditMode, onPageChange = _b.onPageChange;
    var _onChange = function (change) {
        var _a;
        return onPageChange({ data: (_a = {}, _a[change.target.name] = change.target.value, _a) });
    };
    var _onBlur = function (change) {
        if (addOrUpdatePage) {
            addOrUpdatePage({ _id: data.id, data: __assign(__assign({}, data), { title: change.target.value }) })
                .then(function () { return toast.success('Uloženo', { toastId: 'saved' }); });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTitle, null,
            React.createElement(TitlePlaceholder, { style: { height: 10 } }),
            React.createElement(TitleContent, null,
                pageInEditMode &&
                    React.createElement(H1, null,
                        React.createElement(TitleInput, { name: "title", value: data.title, onChange: _onChange, onBlur: _onBlur })),
                isFetching && React.createElement(LazyLoadPlaceholder, null),
                !pageInEditMode &&
                    React.createElement(H1, null, data.title))),
        React.createElement(TitlePlaceholder, { style: { height: 10 } })));
});
